import React from "react";

import RechercheResultCard from "./RechercheResultCard";
import RechercheEmptyState from "./RechercheEmptyState";

import { getVisibleGroups } from "../utils/rechercheUtils";

export default function RechercheResults({
  groups = [],
  total = 0,
  query,
  activeSection,
}) {
  const visibleGroups = getVisibleGroups(groups, activeSection);

  if (!total || visibleGroups.length === 0) {
    return <RechercheEmptyState query={query} />;
  }

  return (
    <div className="space-y-6">
      {visibleGroups.map((group) => (
        <section
          key={group.key}
          className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6"
        >
          <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
            <div>
              <h2 className="text-xl font-bold text-slate-950 dark:text-white">
                {group.label}
              </h2>
              <p className="mt-1 text-sm font-semibold text-slate-500 dark:text-slate-400">
                {group.count} résultat{group.count > 1 ? "s" : ""}
              </p>
            </div>
          </div>

          {group.items.length > 0 ? (
            <div className="grid gap-4">
              {group.items.map((item) => (
                <RechercheResultCard
                  key={`${item.sectionKey}-${item.id}-${item.href}`}
                  item={item}
                  section={group}
                />
              ))}
            </div>
          ) : (
            <p className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-5 text-sm font-semibold text-slate-500 dark:border-slate-800 dark:bg-slate-900/70 dark:text-slate-400">
              {group.emptyLabel}
            </p>
          )}
        </section>
      ))}
    </div>
  );
}